import TourPage from "@/components/TourPage";

export default function TanzaniaSafari2Day() {
  return (
    <TourPage
      tourId="tanzania/safari-2-day"
      title="2 Days Safari to Tanzania"
      duration="2 Days / 1 Night"
      price="Contact for price"
      image="/tanzaniatour.jpg"
      description="Embark on a thrilling 2-day safari adventure to Tarangire National Park and Ngorongoro Crater in Tanzania. Witness the incredible wildlife diversity, including elephants, lions, and wildebeests."
      itinerary={[
        {
          day: 1,
          title: "Arusha to Tarangire National Park",
          description: "Begin your safari adventure in Tarangire National Park.",
          activities: [
            "Pick up from Arusha Hotel and drive to Tarangire National Park",
            "Game drive in the park, spotting elephants, lions, and wildebeests",
            "Lunch at a designated picnic site",
            "Late afternoon drive to Karatu for dinner and overnight"
          ],
          accommodation: "Lodge in Karatu",
          meals: "Lunch, Dinner"
        },
        {
          day: 2,
          title: "Ngorongoro Crater and Return to Arusha",
          description: "Explore the UNESCO World Heritage Site of Ngorongoro Crater.",
          activities: [
            "Descend into Ngorongoro Crater for a game drive with a picnic lunch",
            "Spot a variety of wildlife, including wildebeests, zebras, and elephants",
            "Late afternoon drive back to Arusha, arriving in the evening"
          ],
          meals: "Breakfast, Lunch"
        }
      ]}
      inclusions={[
        "Pick up and drop off at the airport",
        "Mineral water per person per day",
        "Ngorongoro Crater car supplement fee",
        "All park entry fees and concession fees",
        "Government Taxes related to this safari",
        "Private 4x4 safari vehicle with pop-up roof, guaranteed window seat, refrigerator, and USB charging ports",
        "Professional English-speaking safari driver guide",
        "Accommodation and meals in lodges/camps as per itinerary",
        "Accommodation in Arusha before and after safari"
      ]}
      exclusions={[
        "International and domestic flight tickets",
        "Alcoholic and non-alcoholic beverages",
        "Visa fees, travel, and health insurance",
        "Item of personal Nature",
        "Any other items of a personal nature, laundry, telephone, and postage",
        "Meals, drinks, and excursions not described in the itinerary",
        "Gratuities to your guide, hotel staff, and porters",
        "Olduvai Gorge fees",
        "Airport taxes"
      ]}
    />
  );
}
